export const createStringValueFromArray = (
  values: { value: string | number; label: string }[] = []
) => {
  return values.map(({ value }) => value).join(',');
};

export const DEFAULT_LANGUAGE = 'en';

export const languageMap: { [key in MerchantosSupportedLanguages]: string } = {
  en: 'English',
  fr: 'Français',
  nl: 'Netherlands',
  es: 'Español',
  de: 'Deutsch',
};
